import { Controller } from "@hotwired/stimulus";

class UserCheckinAttemptMapController extends Controller {
    static targets = ["map"]
    static values = {
        lat: Number,
        lng: Number,
        neighborhoodGeojson: String
    }

    connect() {
        this.initMap()
    }

    initMap() {
        console.log("initMap - UserCheckinAttemptMapController")

        this.map = new google.maps.Map(this.mapTarget, {
            center: {
                lat: this.latValue,
                lng: this.lngValue
            },
            zoom: 13,
        })
        this.buildMarker(this.latValue, this.lngValue)
        this.drawPolygon();
    }

    buildMarker(lat, lng) {
        const marker = new google.maps.Marker({
            position: {
                lat: lat,
                lng: lng,
            },
            map: this.map
        })
        const infoWindow = new google.maps.InfoWindow({content: 'Attempt location', maxWidth: 200});
        marker.addListener("click", () => {
            infoWindow.open(this.map, marker)
        })
        return marker
    }

    drawPolygon() {
        if (!this.neighborhoodGeojsonValue) {
            return;
        }
        console.log(JSON.parse(this.neighborhoodGeojsonValue))

        const polygon = new google.maps.Data({ map: this.map });
        polygon.addGeoJson(JSON.parse(this.neighborhoodGeojsonValue));

        polygon.setStyle({
            fillColor: 'red',
            strokeWeight: 2,
            strokeColor: 'red'
        });

        let currentInfoWindow = null;
        polygon.addListener('click', (event) => {
            if (currentInfoWindow) {
                currentInfoWindow.close();
            }

            const infoWindow = new google.maps.InfoWindow({
                content: 'User neighborhood',
                position: event.latLng,
            });
            infoWindow.open(this.map);
            currentInfoWindow = infoWindow;
        });
    }
}

export default UserCheckinAttemptMapController;